export const MAX_TOTAL_UPLOAD_SIZE_BYTES = 450 * 1024 * 1024; // 450 MB — BE hard limit is 500 MB

export const SERVER_LIMIT_EXCEEDED_ERROR_MESSAGE = "Total file size exceeds the server limit. Please reduce your selection.";

export const DEFAULT_SITE_ID = 0;
